import React, {useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {DatePicker} from '@material-ui/pickers';
import {dsiCalendar} from '../../../../components/icons/customIcons';
import {SvgIcon} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  datePicker: {
    cursor: 'pointer !important',
    maxWidth: '164px',
    backgroundColor: '#f2f2f2', // Customize background color
    borderRadius: 5, // Customize border radius
    '& .MuiInputLabel-outlined': {
      // Customize label style
      // transform: 'translate(14px, 10px)',
      fontSize: '16px',
      fontWeight: 'normal',
      color: '#666',
    },
    '& .MuiOutlinedInput-input': {
        cursor: 'pointer',
    },
    '& .MuiOutlinedInput-root': {
      // Customize input style
      '& fieldset': {
        borderColor: '#ccc', // Customize border color
      },
      '&:hover fieldset': {
        borderColor: '#666', // Customize hover border color
      },
      '&.Mui-focused fieldset': {
        borderColor: '#6e12b6', // Customize focused border color
      },
    },
  },
  iconButton: {
    padding: theme.spacing(1),
    color: '#666', // Customize icon color
    '&:hover': {
      backgroundColor: 'transparent', // Disable hover background color
    },
    '& .MuiSvgIcon-root': {
      // Customize icon style
      fontSize: '1.5rem',
    },
  },
}));

const CustomDatePicker = ({label, value, onChange, }) => {
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(false);

  const DISABLE_BEFORE_DATE = '04/21/2023' //1 Ordibehesht 1402

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <DatePicker
      // defaultValue={defaultValue}
      variant="inline"
      autoOk
      open={isOpen}
      onOpen={handleOpen}
      onClose={handleClose}
      format="jYYYY/jMM/jDD"
      label={label}
      //Set date limit 
      //Aryan
      minDate={new Date(DISABLE_BEFORE_DATE)}
      // Customize input style
      inputVariant="outlined"
      className={classes.datePicker}
      // Customize icon
      InputProps={{
        startAdornment: (
          <SvgIcon
            viewBox="0 -4 24 24"
            style={{marginLeft: '8px', color: 'rgba(47, 72, 88, 0.6)',cursor: 'pointer', }}
          >
            <path d={dsiCalendar} />
          </SvgIcon>
        ),
      }}
      value={value}
      onChange={onChange}
    />
  );
};

export default CustomDatePicker;
